/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { LoginContentByPass } from "../components/container/login/content-bypass";
import { selectNewProfile } from "../store/newProfile/selector";
import { getAuthToken, getLastVisitedPage } from "../utils/token";

export function Bypass() {
  const navigate = useNavigate();
  const authToken = getAuthToken();
  const profile = useSelector(selectNewProfile);

  useEffect(() => {
    const from = getLastVisitedPage() || "/";

    if (authToken && profile) {
      navigate(from, { replace: true });
    }

    if (authToken && !profile) {
      navigate("/logout");
    }
  }, []);

  return (
    <Container maxWidth={false} disableGutters>
      <LoginContentByPass />
    </Container>
  );
}
